import Flickity from 'flickity';

const selectors = {
  slider: '[data-slider]',
  photo: '[data-grid-slide]',
};

const attributes = {
  showDots: 'data-show-dots',
  groupCells: 'data-group-cells',
};

const sections = {};

class Slider {
  constructor(container, el) {
    this.container = container;
    this.slideshow = el;

    this.pageDots = this.slideshow.getAttribute(attributes.showDots) === 'true';
    this.groupCells = this.slideshow.getAttribute(attributes.groupCells) === 'true';
    this.firstPhoto = this.container.querySelector(selectors.photo);
    const buttonOffset = this.firstPhoto.offsetHeight / 2;
    this.slideshow.style.setProperty('--buttons-top', `${buttonOffset}px`);

    if (!this.slideshow) return;

    this.flkty = null;

    this.init();
  }

  init() {
    const instance = this;
    const sliderOptions = {
      initialIndex: 0,
      accessibility: true,
      autoPlay: false,
      contain: true,
      pageDots: this.pageDots,
      adaptiveHeight: false,
      wrapAround: false,
      groupCells: this.groupCells,
      cellAlign: 'left',
      freeScroll: true,
      prevNextButtons: true,
      draggable: true,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 65,
        y2: 45,
        x3: 20,
      },
      on: {
        ready: function () {
          instance.removeIncorrectAria();
        },
      },
    };
    this.flkty = new Flickity(this.slideshow, sliderOptions);

    this.container.addEventListener('theme:tab:change', () => {
      this.flkty.resize();
    });
  }

  removeIncorrectAria() {
    const slidesHidden = this.slideshow.querySelectorAll('[aria-hidden="true"]');
    slidesHidden.forEach((el) => el.removeAttribute('aria-hidden'));
  }

  onUnload() {
    if (this.slideshow && this.flkty) {
      this.flkty.options.watchCSS = false;
      this.flkty.destroy();
    }
  }
}

const productSliderSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.slider);
    els.forEach((el) => {
      sections[this.id].push(new Slider(this.container, el));
    });
  },
  onUnload(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onUnload === 'function') {
        el.onUnload(e);
      }
    });
  },
};

export {productSliderSection, Slider};
